import axios from 'axios';
import { SCROLL_TO_ERROR_TIMEOUT } from '../constants';

export interface ServerError {
  status?: number;
  response?: {
    data?: unknown;
  };
}

export type SubmitErrorKey = 'validation' | 'unauthorized' | 'server' | 'network' | 'client';

export const scrollToFirstError = () => {
  setTimeout(() => {
    const firstErrorField = document.querySelector('[data-error]');
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, SCROLL_TO_ERROR_TIMEOUT);
};

const isFieldErrors = (data: unknown): data is Record<string, unknown> =>
  typeof data === 'object' && data !== null && !Array.isArray(data);

const readMessage = (messages: unknown): string | null => {
  const message = Array.isArray(messages) ? messages[0] : messages;

  return typeof message === 'string' ? message : null;
};

export const classifyServerError = (err: ServerError): SubmitErrorKey => {
  if (err.status === 401 || err.status === 403) return 'unauthorized';
  if (err.status) return 'server';

  return axios.isAxiosError(err) ? 'network' : 'client';
};

export const handleServerError = <T extends string>(
  err: ServerError,
  setError: (name: T, error: { type: string; message: string }) => void,
  onError: () => void,
  isFieldPresent: (name: string) => boolean
): SubmitErrorKey => {
  const data = err.response?.data;
  let applied = 0;

  if (err.status === 422 && isFieldErrors(data)) {
    Object.entries(data).forEach(([field, messages]) => {
      const message = readMessage(messages);
      if (message === null || !isFieldPresent(field)) return;

      setError(field as T, { type: 'server', message });
      applied += 1;
    });
  }

  onError();

  return applied > 0 ? 'validation' : classifyServerError(err);
};
